<template>
    <div>
        <div class="breadcrumb">
            <Breadcrumb>
                <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
                <Breadcrumb-item>后端学导数据</Breadcrumb-item>
            </Breadcrumb>
        </div>
        <div>
            <Form label-position="left" :label-width="70">
                <Row :gutter="32" index="1">
                    <Col span="6">
                        <FormItem label="选择日期:" v-if="queryParam.dayOfMonth == 0">
                            <DatePicker @on-change="getTimeDateChange"
                                        placement="bottom-start" 
                                        format="yyyy-MM-dd" 
                                        :type="type" 
                                        :value="defaultDate"
                                        placeholder="选择起始时间"
                                        style="width: 100%">
                            </DatePicker>
                        </FormItem>
                        <FormItem label="选择月:" v-if="queryParam.dayOfMonth == 1">
                            <DatePicker @on-change="getTimeMonthChange"
                                        :type="type"
                                        placeholder="选择月"
                                        style="width: 100%">
                            </DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="查看方式:">
                            <Radio-group v-model="queryParam.dayOfMonth" @on-change="search">
                                <Radio label=0>按日查看</Radio>
                                <Radio label=1>按月查看</Radio>
                            </Radio-group>
                        </FormItem>
                    </Col>
                    <Col>
                      <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                            @click="search">搜索
                      </Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="btn-wrap">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading"
            @click="exportData">导出
          </Button>
        </div>

        <List ref="dataList" :tableColumns="table" listUrl="/data/report/querystudyadviserdata"
            :params="queryParam" :onLoading="onLoading" :reload="reload"></List>

        <Modal v-model="tableRulePrompt" title="规则">
            {{tableRulePromptContent}}
            <div slot="footer">
                <Button type="text" size="large" @click="cancel">取消</Button>
                <Button type="primary" size="large" :loading="onLoading" @click="cancel">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            searchLoading: false,
            onLoading: false,
            reload: 0,
            defaultDate: [],
            type: '',
            queryParam: {
                startTime: '',
                endTime: '',
                dayOfMonth: 0
            },
            tableRulePrompt: false,
            tableRulePromptContent: '',
            table: [
                {
                    title: '时间',
                    align: 'center',
                    key: 'day',
                    width: 80,
                    fixed: 'left',
                    render: (h, params)=>{
                        let row = params.row
                        if(this.queryParam.dayOfMonth == 0) return h('div', row.gmtCreate)
                        return h('div', row.day)
                    }
                },
                {
                    title: '包含所有课时学生数',
                    align: 'center',
                    key: 'totalAllCourse',
                    width: 170,
                    fixed: 'left',
                    renderHeader: (h,params)=>{
                        let tableHeader = '外教课>0且中教课>0且陪练课>0'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '包含所有课时学生数');
                    }
                },
                {
                    align: 'center',
                    key: 'totalPaySuccessNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生状态】:常规学生、停课学生、待分配学生'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '总在校付费学生数');
                    }
                },
                {
                    align: 'center',
                    key: 'routineNum',
                    width: 170,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课时条件】：外教课>0且中教课=0且陪练课=0'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '只含外教课学员数');
                    }
                },
                {
                    align: 'center',
                    key: 'chineseNum',
                    width: 170,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课时条件】：外教课=0且中教课>0且陪练课=0'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '只包含中教课学生数');
                    }
                },
                {
                    align: 'center',
                    key: 'partnerNum',
                    width: 170,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课时条件】：外教课=0且中教课=0且陪练课>0'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '只包含陪练课学生数');
                    }
                },
                {
                    align: 'center',
                    key: 'noRoutineNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课时条件】：外教课=0且中教课>0且陪练课>0'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '无外教课时学员数');
                    }
                },
                {
                    align: 'center',
                    key: 'noChineseNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课时条件】：外教课>0且中教课=0且陪练课>0'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '无中教课时学员数');
                    }
                },
                {
                    align: 'center',
                    key: 'noPartnerNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课时条件】：外教课>0且中教课>0且陪练课=0'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '无陪练课时学员数');
                    }
                },
                {
                    align: 'center',
                    key: 'serviceAttributionStudyNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【归属条件】：学导服务'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '学导服务常规生量');
                    }
                },
                {
                    align: 'center',
                    key: 'serviceAttributionAdviserNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【归属条件】：销售独立服务'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '销售服务学生量');
                    }
                },
                {
                    align: 'center',
                    key: 'noServiceAttributionNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【归属条件】：   等待确认归属'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '等待分配学生量');
                    }
                },
                {
                    align: 'center',
                    key: 'stopCourseNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '查询当日总的停课学生量【学生状态】:        停课学生  '
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '停课学生量');
                    }
                },
                {
                    align: 'center',
                    key: 'adviserOnlyNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：订单支付时间为对应日期【支付条件】：支付状态为全额付清【订单类型】：新签【学生量】：一个学生多笔订单只算一次'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '销售净签');
                    }
                },
                {
                    align: 'center',
                    key: 'studyReceiveNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：工单审核通过时间为对应日期【工单审核状态】：已通过'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '学导接收学生数');
                    }
                },
                {
                    align: 'center',
                    key: 'routineStopCourseNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：外教课结课状态变更记录创建时间在对应日期内           【变更后状态】：主修课课结课   '
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '外教课结课学员数');
                    }
                },
                {
                    align: 'center',
                    key: 'chineseStopCourseNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：中教课结课状态变更记录创建时间在对应日期内   【变更后状态】：中教课结课   '
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '中教课结课学员量');
                    }
                },
                {
                    align: 'center',
                    key: 'partnerStopCourseNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：陪练课结课状态变更记录创建时间在对应日期内   【变更后状态】：   陪练课结课  '
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '陪练课结课学员量');
                    }
                },
                {
                    align: 'center',
                    key: 'endCourseNum',
                    width: 150,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：结课状态变更记录创建时间在对应日期内【变更后状态】：  结课学生   '
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '学员结课流失量');
                    }
                },
                {
                    align: 'center',
                    key: 'returnPremiumNum',
                    width: 170,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：退费状态变更记录创建时间在对应日期内 【变更后状态】：退费学生  '
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '后端退费流失学生量');
                    }
                },
            ]
        }
    },
    mounted: function () {
    },
    created: function () {
        let date = new Date()
        let today = this.$moment(new Date()).format('YYYY-MM-DD')
        let sevenDayAgo = this.$moment(new Date(date.getTime() - 168*60*60*1000)).format('YYYY-MM-DD')
        this.defaultDate = [sevenDayAgo, today]
        this.queryParam.startTime = sevenDayAgo
        this.queryParam.endTime = today

        this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month'
    },
    methods: {
        search () {
            console.log(`this.queryParam`, this.queryParam)
            this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month'
            this.reload = new Date().getTime()
        },
        onLoading (loading) {
            this.searchLoading = loading
        },
        showPrompt (value) {
            let self = this
            self.tableRulePrompt = true
            self.tableRulePromptContent = value
        },
        cancel () {
            let self = this
            self.tableRulePrompt = false
        },
        getTimeDateChange (val) {
            this.queryParam.startTime = val[0]
            this.queryParam.endTime = val[1]
        },
        getTimeMonthChange (val) {
            this.queryParam.startTime = val
            this.queryParam.endTime = val
        },
        exportData () {
            this.exportLoading = true
            this.$http.get('/data/report/exporstudytadviserdata', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
                let blob = new Blob([response.data], {type: 'text/csv'})
                let link = document.createElement('a')
                link.target = '_blank'
                link.href = window.URL.createObjectURL(blob)
                link.download = '后端学导数据.csv'
                link.click()
                this.exportLoading = false
            } else {
                this.$Message.error(response.msg)
            }
            }).catch((e) => {
            this.exportLoading = false
            })
        }
    }
}
</script>

<style scoped>
  .btn-wrap {
    text-align: right;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// StudyAdviserList.vue?4f00fec4